
var sponsorsImgRoot = "static/images/sponsors/";
var speakersImgRoot = "static/images/speaker/";
var tutorialImgRoot = "static/images/tutorial/";
var workshopImgRoot = "static/images/workshop/";
var aprspeakersImgRoot = "static/images/aprspeakers/";

export default{
  sponsors:{
    bojin:[
      {
        name: "AutoDL",
        nameabb:"AutoDL",
        icon: sponsorsImgRoot+"AutoDL_1.png",
        href:"https://www.autodl.com/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "OPPO",
        nameabb:"OPPO广东移动通信有限公司",
        icon: sponsorsImgRoot+"oppo.png",
        href:"https://www.oppo.com/cn/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "墨奇智能",
        nameabb:"墨奇智能",
        icon: sponsorsImgRoot+"moqi.png",
        href:"https://www.morphi.com/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "小米集团",
        nameabb:"小米集团",
        icon: sponsorsImgRoot+"Xiaomi_Logo.png",
        href:"https://www.mi.com/index.html",
        isnew:false,
        acttitle:"小米AI技术沙龙邀您面对面交流，共话AI新未来！",
        time:"5月8日15:30-17:30",
        addr:"武汉国际会议中心，一楼楚信厅",
        content:"小米大模型、智驾、机器人、相机算法等技术团队大咖与您面对面深度对话，聚焦技术行业趋势、企业场景和技术进展，以及学术研究与产业落地结合等议题，为您做专业解答和发展建议，更有资深HR对小米校招政策做1V1答疑，欢迎报名参会！",
        actbaoming:"https://mp.weixin.qq.com/s/C3u5XPET-kRcP4xHKxZXjA",
        actref:"https://mp.weixin.qq.com/s/C3u5XPET-kRcP4xHKxZXjA",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "华为",
        nameabb:"华为",
        icon: sponsorsImgRoot+"huawei.png",
        href:"https://www.huawei.com/cn/",
        isnew:false,
        acttitle:"华为邀您探索AI无限可能",
        time:"5月8日",
        addr:"武汉国际会议中心 华为展台A2",
        content:"华为致力于把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界。本次大会，华为智驾、媒体、终端相机算法等技术团队专家、大咖会与您面对面深度对话，还有资深HR为您解读校招政策、职业建议，一站式搞定，欢迎报名参会！招聘链接：https://career.huawei.com/cn/campus-recruitment",
        actbaoming:"https://tyao.cc/lnk/t/2vpMV4I",
        actref:"https://tyao.cc/lnk/t/2vpMV4I",
        actimage:sponsorsImgRoot+"d"
      },
    ],
    jinpai:[
      {
        name: "合合信息",
        nameabb:"合合信息",
        icon: sponsorsImgRoot+"hehexinxi_1.pic",
        href:"https://www.intsig.com",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "极市平台",
        nameabb:"极市平台",
        icon: sponsorsImgRoot+"jishipingtai.png",
        href:"https://www.cvmart.net/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      
      {
        name: "杭州睿琪软件有限公司",
        nameabb:"杭州睿琪软件有限公司",
        icon: sponsorsImgRoot+"ruiqi.png",
        href:"https://www.glority.cn/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "美团",
        nameabb:"美团",
        icon: sponsorsImgRoot+"meituan.png",
        href:"https://www.meituan.com/technology",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "深圳佑驾创新科技股份有限公司",
        nameabb:"深圳佑驾创新科技股份有限公司",
        icon: sponsorsImgRoot+"youjiachuangxin.png",
        href:"https://www.minieye.cc",
        isnew:false,
        acttitle:"洞见智驾前沿，与佑驾创新共创智能驾驶新视界",
        time:"5月8-10日",
        addr:"B4 佑驾创新展位、3F 江耀厅",
        content:"探索智能驾驶与智能座舱解决方案，及L4自动驾驶产品与应用场景。届时将设有技术专家workshop演讲环节，同时活动现场将围绕智能驾驶核心技术、行业发展趋势、实习及校招机会展开深度交流，佑驾创新HR将提供1对1职业沟通与简历指导，简历更有机会直达业务团队。欢迎各位报名交流。",
        actbaoming:"https://mp.weixin.qq.com/s/lcmMMbmBPv6LJNyASlugAQ",
        actref:"https://mp.weixin.qq.com/s/lcmMMbmBPv6LJNyASlugAQ",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "影石创新科技股份有限公司",
        nameabb:"影石创新科技股份有限公司",
        icon: sponsorsImgRoot+"yingshichuangxin.png",
        href:"https://www.insta360.com/cn/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "百度",
        nameabb:"百度",
        icon: sponsorsImgRoot+"baidu.png",
        href:"https://home.baidu.com/home/index",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "九章云极",
        nameabb:"九章云极",
        icon: sponsorsImgRoot+"jiuzhangyunji.png",
        href:"https://www.datacanvas.com/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "淘天集团",
        nameabb:"淘天集团",
        icon: sponsorsImgRoot+"taotian.png",
        href:"https://talent.taotian.com/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "卓驭科技",
        nameabb:"卓驭科技",
        icon: sponsorsImgRoot+"zhuoyu.png",
        href:"https://www.zyt.com/zh",
        isnew:false,
        acttitle:"卓驭邀您解码移动物理AI，共话出行新未来",
        time:"5月8-10日，可根据报名意向灵活安排",
        addr:"B01展台",
        content:"卓驭AI首席技术官及各领域算法专家与您一对一深入交流行业动态、公司战略、学术研究、校企合作等核心议题，更有HR现场为您介绍卓驭顶尖人才招聘领航者校招及实习计划，欢迎各位莅临展台，共话技术，共启未来！",
        actbaoming:"https://mp.weixin.qq.com/s/iRdVgjSO9JdIFqQ5cPdfzg",
        actref:"https://mp.weixin.qq.com/s/iRdVgjSO9JdIFqQ5cPdfzg",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "腾讯",
        nameabb:"腾讯",
        icon: sponsorsImgRoot+"tencent.png",
        href:"https://join.qq.com",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "CANVA可画",
        nameabb:"CANVA可画",
        icon: sponsorsImgRoot+"kehua.png",
        href:"http://canva.cn",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "Weitu AI",
        nameabb:"Weitu AI",
        icon: sponsorsImgRoot+"Weitu_ai.png",
        href:"https://weitu.ai/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "北京英博数科科技有限公司",
        nameabb:"北京英博数科科技有限公司",
        icon: sponsorsImgRoot+"yingboyun.png",
        href:"https://www.ebtech.com/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "银河通用机器人",
        nameabb:"银河通用机器人",
        icon: sponsorsImgRoot+"yinhetongyong_1.png",
        href:"https://www.galbot.com/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
    ],
    yinpai:[
      {
        name: "思腾合力（天津）科技有限公司",
        nameabb:"思腾合力（天津）科技有限公司",
        icon: sponsorsImgRoot+"sitengheli.png",
        href:"https://www.aiserver.cn/index",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "杭州硅行智能科技有限公司",
        nameabb:"杭州硅行智能科技有限公司",
        icon: sponsorsImgRoot+"guihangzhineng.png",
        href:"https://www.boundlessi.com/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "北京安联通科技有限公司",
        nameabb:"北京安联通科技有限公司",
        icon: sponsorsImgRoot+"anlian.png",
        href:"https://www.an-link.com/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "美图",
        nameabb:"美图",
        icon: sponsorsImgRoot+"meitu.png",
        href:"https://mtlab.meitu.com",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      
      {
        name: "虹软",
        nameabb:"虹软",
        icon: sponsorsImgRoot+"hongruan.png",
        href:"https://www.arcsoft.com.cn/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "北京金山办公软件股份有限公司",
        nameabb:"北京金山办公软件股份有限公司",
        icon: sponsorsImgRoot+"jinshan_1.png",
        href:"https://www.wps.cn/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
      {
        name: "OpenSeed",
        nameabb:"OpenSeed",
        icon: sponsorsImgRoot+"openseed_2.png",
        href:"https://www.openseed.hk/",
        isnew:false,
        acttitle:"",
        time:"",
        addr:"",
        content:"",
        actbaoming:"",
        actref:"",
        actimage:sponsorsImgRoot+"d"
      },
    ]
  },

  // {
    // name: "OPPO",
    // nameabb:"OPPO广东移动通信有限公司",
    // icon: sponsorsImgRoot+"oppo.png",
    // href:"https://www.oppo.com/cn/",
    // isnew:false,
    // acttitle:"",
    // time:"6月10日-12日",
    // addr:"B02展台",
    // content:"OPPO邀你相约太湖“学术华尔兹”",
    // actbaoming:"点击报名",
    // actref:"https://mp.weixin.qq.com/s/7c4qZgkLaxBCwKn2Tuc-bw",
    // actimage:sponsorsImgRoot+"d"
  // },
  speakers:{
    keynote:[
      
     
    ],
    invited:[
      
      {
        name:"凌海滨",
        organization:"西湖大学",
        image:speakersImgRoot+"linghaibin.jpeg",
        reportTitle:"VALSAR: Vision And Learning for Spatial Augmented Reality",
        reportAbstract:"空间增强现实（SAR）是一个历史悠久且具有广泛潜在应用前景的领域，但其发展长期受限于投影仪-相机系统（ProCams）等软硬件技术瓶颈。本报告将介绍我们团队近年来在融合视觉与机器学习技术推动智能投影相机系统发展方面所取得的一系列进展。首先，我们提出并开发了以DeProCams为代表的端到端可训练模型，该模型能够显式学习ProCams的光度与几何映射，从而实现对空间增强现实中若干基本任务的统一求解，包括基于图像的重光照、投影仪补偿以及深度/法向重建。在此基础上，我们进一步提升了投影补偿算法的鲁棒性与泛化能力。最后，我们探索了将视觉语言模型与投影过程相结合，为高效、自适应地生成投影内容开辟了新的方向。本研究主要与黄兵姚合作完成。",
        resume:"凌海滨教授于1997年与2000年分别获得北京大学的学士与硕士学位，并于2006年获得马里兰大学帕克分校博士学位，随后在于加州大学洛杉矶分校完成博士后训练。早期工业界经历包括在微软亚洲研究院担任助理研究员（2000-2001年）以及在西门子研究院担任研究科学家（2007-2008年）。2008年，他加入天普大学担任助理教授，后晋升为副教授。2019年，他转至纽约州立大学石溪分校，受聘为SUNY Empire Innovation教授。2025年，他加入西湖大学，现任讲席教授。他的研究涵盖计算机视觉、增强现实、医学影像分析、机器学习以及科学人工智能等多个领域。所获荣誉包括ACM UIST 最佳学生论文奖（2003年）、美国国家科学基金会CAREER奖（2014年）、IEEE VR最佳期刊论文奖（2021年）以及IEEE VR最佳论文奖（2026年）等。他曾担任或现任《IEEE模式分析与机器智能汇刊》（PAMI）、《IEEE可视化与计算机图形学汇刊》（TVCG）、《计算机视觉与图像理解》（CVIU）以及《模式识别》（PR）等期刊的编委。同时，他也长期担任CVPR、ICCV、ECCV、ACM MM等会议的领域主席。他是IEEE会士。"
      },
      {
        name:"黄华",
        organization:"北京师范大学",
        image:speakersImgRoot+"huanghua.jpeg",
        reportTitle:"教育文档处理的关键技术",
        reportAbstract:"教育文档处理已成为教育人工智能领域的核心研究方向之一。本报告将系统梳理教育文档处理领域的关键技术进展，重点围绕复杂教育版面解析、手写内容识别、结构化表达理解以及面向教育场景的智能分析等任务，清晰呈现相关技术方法的发展脉络与当前研究现状，深入剖析教育场景下，文档内容多样性、结构复杂性、表达形式灵活性等固有特点所带来的技术瓶颈与挑战，探讨通用文档智能方法在教育场景中的适配性、应用局限及优化改进路径，并结合教育教学实际应用需求，展望教育文档处理技术的未来发展趋势与广阔应用前景。",
        resume:"黄华，北京师范大学人工智能学院教授，院长，智能技术与教育应用教育部工程研究中心、教育人工智能北京市重点实验室主任。国家级高层次人才，中国青年科技奖获得者。主要从事图像/视频处理、人工智能方面的研究工作。主持国家自然科学基金重点项目、国家重点研发计划项目等；发表CCF A类论文百余篇，获授权国家发明专利60余项，部分成果在工业、国防、互联网行业得到应用。兼任《计算机辅助设计与图形学》、《电子与信息学报》副主编。"
      },
      {
        name:"曹汛",
        organization:"南京大学",
        image:speakersImgRoot+"caoxun.jpg",
        reportTitle:"AI-Empowered Computational Cameras: Beyond Human Vision",
        reportAbstract:"Traditional optical imaging faces fundamental physical limitations in spatial resolution, depth perception, field of view and spectral response. AI-empowered computational imaging combines optical encoding hardware and intelligent reconstruction algorithms to break these constraints. This talk explores advanced computational camera techniques for high-fidelity spatial imaging, 3D structural sensing, wide-angle acquisition and spectral feature recovery. Driven by artificial intelligence, modern imaging evolves from basic visual recording to semantic and cognitive perception. As a cross-disciplinary technology, computational cameras lay solid foundations for industrial detection, security surveillance, unmanned systems and scientific observation, pushing machine vision beyond the limits of human vision.",
        resume:"曹汛，南京大学教授，博士生导师，国家“新一代人工智能”重大专项专家组成员，南京市青科协会长。主持国家重大仪器等科研项目，融合多学科建立成果转化平台，指导学生多次获互联网+/国创赛、挑战杯等全国大学生重要赛事特等奖和金奖。理论研究成果发表Nat. Nanotech.、Nat Comm.、Optica、IEEE T-PAMI、《中国科学》、《电子学报》以及CVPR等会议，撰写Springer.视觉大百科全书《光谱成像》章节；研究入选欧洲图形图象领域年度研究进展报告，被写入M.I.T.教材《计算摄像》。研制了系列智能成像仪器装置，并在安全侦察、工业检测领域成功应用，获国家技术发明奖一等奖（2012）、教育部技术发明一等奖（2011）、Microsoft Fellowship（2011）、中国青年五四奖章（2022）、中国电子学会科技进步一等奖（2025）。"
      },
      {
        name:"潘纲",
        organization:"浙江大学",
        image:speakersImgRoot+"pangang.jpg",
        reportTitle:"脑机增强智能新范式",
        reportAbstract:"人工智能、神经科学、微电子、神经工程等领域的最新进展，显示出计算系统和生命体之间的融合成为可能并日趋明显。以脑机接口为代表的神经技术的快速发展使得脑与机之间的结合越来越紧密，脑机融合及其一体化已成为人工智能发展的一个重要趋势。如何让生物脑与机器脑互为增强并协同工作，是当前人工智能与脑认知科学交叉领域的重要课题。本报告将探讨脑机增强智能这一新范式，介绍其产生背景、概念与形式等，并分享人工智能增强的赛博格生命体、脑机语义增强的大模型等具体实例。",
        resume:"潘纲，浙江大学计算机学院求是特聘教授，VALSE指导委员会委员，脑机智能全国重点实验室主任，国家杰出青年科学基金获得者，中国认知科学学会副理事长，中国人工智能学会会士、脑机融合与生物机器智能专委会主任委员。研究方向为类脑计算、脑机接口、人工智能等。指导学生获多项国际会议或期刊的最佳论文奖、最佳论文提名奖、时间考验论文奖等。"
      },
      {
        name:"虞晶怡",
        organization:"上海科技大学",
        image:speakersImgRoot+"yujingyi.jpeg",
        reportTitle:"Speaking the Language of Space: Automating 3D Workflows with Agentic Vision",
        reportAbstract:"The 3D vision community has recently witnessed a Cambrian explosion of foundation models. With breakthroughs like CLAY for generation and SAM3D for scene perception, we now possess a vast and powerful toolbox. However, the next paradigm shift lies not just in building more tools, but in orchestrating them. In this keynote, we present a big-picture perspective on the transition from manual 3D workflows to Agentic 3D Vision. We will discuss how to systematically organize our current 3D tools, investigate their limits, and identify the missing links—specifically in modeling deep geometric relationships and developing new 3D-grounded languages for AI agents.",
        resume:"虞晶怡教授，IEEE Fellow、美国光学学会 OSA Fellow、智能感知与人机协同教育部重点实验室主任。他于 2000 年获美国加州理工学院（Caltech）双学士学位和杰出毕业生奖，2005 年获美国麻省理工学院（MIT）博士学位。现任上海科技大学副校长、讲席教授。他先后获得美国国家科学基金 NSF CAREER Award、美国空军研究院 YIP Award、上海市白玉兰荣誉奖等。他曾获多个计算机领域顶会最佳论文奖，包括 2025 年 ACM SIGGRAPH 最佳论文奖、2024和2025连续两年获得芯片设计顶会 DAC 最佳论文提名奖。他亦担任顶会 CVPR 2021 和 ICCV 2027 的程序主席、ICCV 2025 的大会主席。"
      },
      // {
      //   name:"凌海滨",
      //   organization:"西湖大学",
      //   image:speakersImgRoot+"linghaibin.jpeg",
      //   reportTitle:"",
      //   reportAbstract:"",
      //   resume:""
      // },
    ],
    aprspeakers:[
      {
        name:"彭宇新",
        organization:"北京大学",
        image:aprspeakersImgRoot+"pengyuxin.jpg",
        reportTitle:"细粒度多模态大模型",
        reportAbstract:"多模态大模型在通用任务上表现出色，但缺乏细粒度感知能力，如何做到又广(开域泛化能力)又深(细粒度感知能力)，是多模态大模型亟需解决的关键问题。本报告将从类别、空间、时间三个感知维度阐释“细粒度多模态大模型”的定义，介绍近年来的主要研究进展，包括细粒度图像分类大模型、细粒度空间推理与占用预测、细粒度美学理解、细粒度运动分析等方法与技术，同时深入分析其优缺点和应用场景，最后将对细粒度多模态大模型的未来发展趋势进行展望。",
        resume:"彭宇新，北京大学二级教授、博雅特聘教授，IEEE/CCF/CAAI/CIE/ CSIG Fellow，2019年国家杰青，2025年国家杰青延续资助，2019年国家万人领军人才，2018年科技部中青年科技创新领军人才，863项目首席专家，国家重点研发计划“社会治理与智慧社会科技支撑（平安中国）”重点专项总体专家组专家，中国工程院“人工智能2.0”规划专家委员会专家，中国人工智能产业创新联盟专家委员会主任，中国图象图形学学会副理事长，北京图象图形学学会副理事长。主要研究方向为多媒体分析、计算机视觉、人工智能。以第一完成人获2016年北京市科学技术奖一等奖和2020年中国电子学会科技进步奖一等奖，2008年获北京大学宝钢奖教金优秀奖，2017年获北京大学教学优秀奖。主持了863、国家自然基金重点（2项）、北京自然基金联合基金重点、发改委专项等40多个项目。发表TPAMI、IJCV、CVPR、NeurIPS、ICML等ACM/IEEE Trans.和CCF A类论文180多篇，获最佳论文奖2次。参加10届（10年）由美国国家标准与技术研究院（NIST）举办的国际评测TRECVID视频搜索比赛，均获第一名，参赛队伍包括斯坦福大学、卡内基梅隆大学、牛津大学等。成果应用于国家网信办、公安部、国家广播电视总局等重要单位以及华为、腾讯、快手、蔚来、美团、中国电信、中国铁塔等头部企业。担任IEEE TCSVT高级领域编委、IEEE TMM等期刊编委，培养博士生获中国计算机学会、中国电子学会等优博。"
      },
      {
        name:"欧阳万里",
        organization:"深圳河套学院、上海人工智能实验室",
        image:aprspeakersImgRoot+"ouyangwanli.jpg",
        reportTitle:"人工智能助力科学发现",
        reportAbstract:"本报告系统梳理 2025 至 2026 年度 AI for Science（AI4S）领域关键进展，聚焦人工智能与基础科学交叉融合的范式变革，为 VALSE 参会学者呈现领域全景与前沿趋势。过去一年，AI4S 不再局限于单点算法优化与局部任务辅助，逐步形成数据 — 模型 — 智能体 — 实验平台的全链条技术体系，在物理、化学、材料、生物等学科实现规模化落地。报告从基础模型、科学智能体、典型学科应用、算力与数据基础设施等维度总结年度成果，剖析当前挑战与未来方向，为视觉与学习方法向基础科学领域迁移提供重要参考。",
        resume:"欧阳万里，深圳河套学院副院长，香港中文大学教授，上海人工智能实验室科学智能中心领军科学家，曾任悉尼大学电子信息工程学院研究主任。其团队在ImageNet和COCO竞赛多次获得第一。获IEEE TCSVT期刊最佳论文，ACL杰出论文，两篇文章入选paperdigest CVPR/ICCV最有影响力的文章。入选「人工智能全球2000位最具影响力学者榜」前100名学者。担任人工智能领域顶级期刊TPAMI，IJCV副编，CCF-A类会议CVPR、NeurIPS、ICCV资深领域主席。其团队现已推出OWL·灵鉴、书生·风乌（气象）、书生·瞳真（裸眼3D）、书生·丰登（育种）、书生·翼飞（翼型设计）、书生·鉴原（化学）、书生·言普（谱学）等科学领域模型。"
      },
      {
        name:"戴国浩",
        organization:"上海交通大学",
        image:aprspeakersImgRoot+"daiguohao.jpg",
        reportTitle:"大模型高效计算与推理",
        reportAbstract:"随着模型参数爆炸式增长，推理性能与实际需求差距显著。过去一年，算法侧以多头潜在注意力（MLA）、推测解码等新范式压缩KV缓存并加速生成，FlashAttention-3实现约1.5–2倍提速；系统侧超节点架构与分离式推理推高单节点吞吐至数万tokens/s量级；硬件侧晶圆级集成、3D堆叠等新集成形态开始落地。本报告将从算法、系统、硬件三个层面阐述大模型高效推理的核心技术发展，并以推测性方法为核心，从信息论的角度介绍推测性方法的分类和典型工作，最后探讨高效推理的未来趋势、新方向与新挑战。",
        resume:"戴国浩，主要研究方向为稀疏计算电路与系统。分别于2014年和2019年在清华大学电子工程系获得工学学士和博士学位。在相关领域的国际顶级会议和期刊发表论文80余篇，谷歌学术施引千余次。担任领域内多个国际会议TPC和期刊审稿人、Ph.D. Forum at DAC 2024联席主席等职务，发表论文曾获FPGA 2025、ASP-DAC 2025、DATE 2024、ASP-DAC 2019最佳论文奖，DATE 2023、DAC 2022、DATE 2018最佳论文奖提名。曾参与指导学生获ACM 2021 SRC 全球第三，MICRO 2020 SRC全球第一。个人荣获2024年算力中国·青年先锋人物奖、2022年WAIC 云帆奖、2021年NeurIPS BIGANN竞赛全球冠军等荣誉。"
      },
      {
        name:"郝建业",
        organization:"天津大学",
        image:aprspeakersImgRoot+"haojianye.jpg",
        reportTitle:"基于大语言模型的智能体",
        reportAbstract:"大模型智能体已从单轮对话交互迈入自主规划、长效执行、工程化落地的新阶段，也涌现出以OpenClaw为代表的一系列智能体工程化框架，但仍面临原生大模型工具调用混乱、长任务执行断裂、记忆管理低效、自主行为不可控等核心痛点问题。本报告将从工具调用、超长任务规划、安全管控、智能记忆等方面系统梳理行业最新技术进展，以及代表性的智能体产业落地实践。",
        resume:"郝建业博士，天津大学教授，国家优青。主要研究方向为强化学习、具身智能和多智能体系统。在Nature Communications/Machine Intelligence和ICML/NeurIPS/ICLR等人工智能领域CCF-A类国际会议发表论文100余篇，获国际会议最佳论文奖4次，NeurIPS大会竞赛冠军4次，中国图像图形学学会科技进步一等奖（第一），中国电子学会自然科学一等奖（第二）等。曾先后任华为决策推理实验室主任、大模型算法实验室主任、华为医疗军团副总裁，负责华为决策智能领域技术创新和产业落地，从0到1孵化多项公司级产业项目，团队成果在国产工业基础软件智能化、基础和行业大模型、自动驾驶、5G网络优化、工业物流调度、具身智能等领域广泛落地应用。"
      },
      {
        name:"高林",
        organization:"中国科学院计算技术研究所",
        image:aprspeakersImgRoot+"gaolin.jpg",
        reportTitle:"以人为中心的视觉内容生成",
        reportAbstract:"随着几何表征与生成模型的发展，数字人技术范式逐渐形成了以重建和生成为核心的两大方向。从展示维度上分为视频数字人和三维数字人。本报告从三维数字人与视频数字人两个方向进行梳理：在三维数字人领域，高斯泼溅已成为其主流表示方式，重建方法大致可以分为“基于网格的高斯表示”和“通过特征图预测高斯属性”两类；生成方面则主要包括利用视频生成模型等2D先验以及构造前馈模型两种路径。在视频数字人领域，围绕语音驱动、动作迁移等任务，如何将控制信息注入到视频生成模型中是生成数字人视频的重要一环，根据控制信号表示的形式，现有方法可以分为显式控制信号表示（如人体关键点）和隐式控制信号表示（如从视频中提取的潜在编码）两类。视频模型和三维模型之间的界限正在逐渐被打破，不同技术路线也在不断融合，推动数字人技术持续发展。",
        resume:"高林，中国科学院计算技术研究所研究员、博士生导师、泛在计算系统研究中心副主任、中国科学院大学岗位教授。在清华大学获得博士学位。研究方向为计算机图形学、三维计算机视觉。在SIGGRAPH、TPAMI、TVCG等期刊会议发表论文100余篇，研发的人脸AIGC的APP被全球180余个国家或者地区的用户所使用。现任或者曾任亚洲图形学学会秘书长， CSIG三维视觉专委副主任，SIGGRAPH技术论文程序委员会委员，CVPR领域主席，IEEE TVCG编委，作为项目负责人承担国家重点研发计划、国家自然科学基金委优青等项目，曾获得亚洲图形学会青年学者奖，吴文俊人工智能优秀青年奖，CCF技术发明一等奖等奖励。"
      },
      {
        name:"秦杰",
        organization:"南京航空航天大学",
        image:aprspeakersImgRoot+"qinjie.jpg",
        reportTitle:"开放世界目标检测",
        reportAbstract:"本报告聚焦大模型时代下的开放世界目标检测。首先，总结近一年该领域的主要研究进展与技术路线，分别从图像、视频、三维场景等方面介绍相应的关键技术与最新成果；其次，阐述开放世界目标检测在具身智能任务中的典型应用；最后，展望开放世界目标检测的未来趋势与关键挑战。",
        resume:"秦杰，南京航空航天大学人工智能学院副院长，教授、博士生导师，脑机智能技术教育部重点实验室副主任，国家级青年人才，江苏省杰青，中国科协海智特聘专家，中国图学学会数字媒体专委会副主任。主要从事计算机视觉、具身智能和多媒体等领域研究，重点关注面向开放动态环境的具身智能感知。发表论文100余篇，其中CCF A类论文50余篇，Google Scholar引用6800余次，H指数42。获中国图象图形学学会自然科学奖二等奖（排名1）、CCF A类会议ACM MM 2023唯一荣誉提名奖（1/3072）等。担任CCF A类期刊IEEE TIP编委、IJCV客座编委，CCF B类期刊Neural Networks编委，CCF A类会议NeurIPS、ICML、ICLR、AAAI、ACM MM领域主席等。主持国家自然科学基金联合重点、面上项目，新一代人工智能国家科技重大专项课题，江苏省杰出青年基金等国家级/省部级项目。"
      },
      {
        name:"张正",
        organization:"哈尔滨工业大学（深圳）",
        image:aprspeakersImgRoot+"zhangzheng.jpg",
        reportTitle:"端侧轻量化大模型",
        reportAbstract:"随着大模型从“参数竞赛”转向“效能落地”，端侧轻量化大模型已成为释放其应用潜力的关键路径。本报告将系统回顾该领域在架构演进、模型压缩、高效推理及系统协同方面的核心进展与未来趋势。在架构演进上，重点分析线性注意力机制如何实现长序列的高质量建模；在模型压缩上，深入分析量化剪枝与KV Cache压缩技术；在高效推理上，汇总快慢思考模型在资源受限环境下的动态推理研究思路，进而介绍端侧交互与端云协同的前沿探索。最后，展望端侧轻量化面临的开放挑战，系统拓展端侧轻量化的持续创新如何推动大模型从“可用”迈向“无处不在的智能”。",
        resume:"张正，哈尔滨工业大学 (深圳)长聘教授，国家级青年人才，广东省珠江学者。长期从事高效能多模态机器学习的研究，专注于高效与可信大模型，出版中英文学术专著/教材4部，发表IEEE/ACM 汇刊和CCF A类论文100余篇，谷歌引用1.4万余次。主持国家级和省部级自然科学基金、深圳市科技创新基金以及阿里巴巴创新研究计划、华为合作基金等科研项目10余项。受邀担任IEEE TIP、IEEE TIFS、IEEE TAFFC等期刊编委以及Information Sciences期刊高级编辑，常年受邀担任ICML、NeurIPS、ICLR、CVPR、AAAI、ACM MM等CCF A 类会议的领域主席。"
      },
      {
        name:"韩波",
        organization:"香港浸会大学",
        image:aprspeakersImgRoot+"hanbo.jpg",
        reportTitle:"迈向可信大模型:学习，推理和泛化",
        reportAbstract:"可信是大模型从\"能用\"走向\"好用\"的关键，也是当前大模型发展面临的重要挑战，涉及能力、鲁棒性、安全性与可解释性等多个层面。本报告围绕可信大模型的学习、推理与泛化三条主线梳理代表性进展。首先，从学习角度回顾对齐与反学习等方法如何塑造模型的行为边界与安全属性；其次，从推理角度介绍测试时增强和强化学习等技术如何提升复杂任务下的推理可靠性；进而，从泛化角度探讨测试时适应与自进化等机制如何支撑模型在开放环境中的稳健表现，并结合AI for Science等典型场景展示落地潜力。最后，展望可信大模型未来的发展趋势与潜在挑战。",
        resume:"韩波，香港浸会大学计算机系机器学习方向长聘副教授、博士生导师，可信机器学习与推理组主任，日本理化学研究所先进智能中心项目梅峰访问科学家，其研究方向为机器学习、深度学习、基础模型及其应用。曾担任香港科技大学（广州）数据科学与分析学域访问副教授，MBZUAI机器学习系访问学者，微软研究院和阿里巴巴达摩院访问研究员，以及日本理化学研究所先进智能中心项目博士后研究员。在悉尼科技大学获得博士学位。合著了三本机器学习专著，分别发表在麻省理工学院出版社、施普林格自然出版社和Foundations and Trends系列期刊。目前担任NeurIPS和ICML高级领域主席，以及ICLR、UAI和AISTATS领域主席。还担任IEEE TPAMI、MLJ和JAIR副主编，以及JMLR和MLJ编委。个人主页：https://bhanml.github.io"
      },
      {
        name:"邓磊",
        organization:"清华大学",
        image:aprspeakersImgRoot+"denglei.jpg",
        reportTitle:"脉冲神经网络",
        reportAbstract:"脉冲神经网络是重要的类脑计算模型之一，其丰富的时空动力学和稀疏脉冲编码被认为具有处理时序信息的巨大潜力。然而，目前对于脉冲神经网络模型的建模方式、学习方法、优势应用等研究尚不充分、理解尚不深入，尤其如何高效利用其时空动力学和稀疏脉冲编码等特性发挥任务级优势还未被充分展示。本次报告将系统性介绍脉冲神经网络及其建模学习概念，揭示其区别于人工神经网络的异同，梳理过去年度该领域的研究进展，重点讨论脉冲神经网络的底层优势和应用案例，探讨该领域的困境与突围思路。",
        resume:"邓磊，清华大学副教授、博导，仪器科学与技术研究所副所长，国家高层次青年人才，IEEE高级会员。从事类脑智能芯片及算法研究10余年，在Nature、Nature Communications等发表论文100余篇，谷歌引用13000余次，获授权专利30余项。担任Frontiers in Neuroscience期刊副主编、中国人工智能学会脑机融合专委会委员、中国认知科学学会计算神经工程专委会委员和多个国际会议分论坛主席及程序委员会委员。入选ScholarGPS全球前0.05%顶尖学者榜单、教育部青年科学奖、北脑青年学者、吴文俊人工智能优秀青年奖、MIT TR 35 China、清华大学学术新人奖等荣誉，代表成果获中国科学十大进展、北京市自然科学一等奖、自动化学会自然科学一等奖、计算机学会技术发明一等奖等奖项。"
      },
      {
        name:"崔兆鹏",
        organization:"浙江大学",
        image:aprspeakersImgRoot+"cuizhaopeng.jpg",
        reportTitle:"物理驱动的空间智能",
        reportAbstract:"空间智能正从“看懂三维世界”迈向“理解物理世界并自主行动”。过去一年，随着三维视觉、具身智能与世界模型等方向的快速发展，研究重点正由几何重建与语义理解，进一步拓展至物理感知、动态推演与统一建模，使智能体具备预测未来、交互推理与安全决策能力。本报告将梳理近一年物理驱动的空间智能领域的重要进展，涵盖物理三维表征、世界模型、交互决策等方向，并对未来工作进行展望。",
        resume:"崔兆鹏，浙江大学计算机科学与技术学院“百人计划”研究员、博士生导师，国家级青年人才计划入选者。曾任瑞士苏黎世联邦理工学院计算机视觉和几何实验室高级研究员。研究方向为三维计算机视觉，主要包括三维重建、三维理解、三维生成和运动规划等。近年来在计算机视觉、图形学与机器人等领域的顶级期刊和会议上发表论文60余篇，曾主持国家自然科学基金面上、专项项目等。曾担任领域内顶级会议CVPR、ECCV领域主席和ICRA、IROS副编委等，曾获ICRA 2020机器视觉最佳论文提名、IROS 2021安全、安保和救援机器人最佳论文提名、3DV 2024最佳论文荣誉提名。"
      },
      {
        name:"杨学",
        organization:"上海交通大学",
        image:aprspeakersImgRoot+"yangxue.jpg",
        reportTitle:"有向目标检测",
        reportAbstract:"本年度工作围绕有向目标检测的核心挑战，从三个维度展开系统性探索：监督模式上，从全监督检测迈向弱监督与高效数据训练，显著降低标注成本；模型架构上，从专有小模型延伸至大模型新范式，提升泛化与表征能力；感知尺度上，从小幅面局部感知迈向大幅面全局推理与理解一体化，实现面向场景理解的深度解译。",
        resume:"杨学，上海交通大学自动化与感知学院长聘教轨助理教授，主持国自然及上海市青年基金项目，曾入选第十届中国科协青年人才托举工程、中国计算机学会优博、上海市启源青年学者，并连续两年入选爱思唯尔中国高被引学者名单和连续三年入选全球前2%顶尖科学家榜单。研究方向为多模态大模型、空间智能和遥感影像解译。在CCF-A类顶级期刊和会议上发表70余篇论文，包含一篇最具影响力AAAI21论文榜首和遥感期刊年度最佳论文，谷歌学术引用累计超过1.1万次，并担任ICLR/AAAI/NeurIPS顶级会议领域主席。"
      },
      {
        name:"傅朝友",
        organization:"南京大学",
        image:aprspeakersImgRoot+"fuchaoyou.jpg",
        reportTitle:"Omni大模型",
        reportAbstract:"Omni大模型是一类能够统一处理文本、图像、音频、视频等多种模态信息的人工智能模型。本报告将系统回顾过去一年该领域的技术进展与代表性成果，涵盖模型架构演进、全模态能力提升、开源生态发展及模型能力评测等方面，并结合当前发展趋势，分析未来面临的挑战与潜在机遇。",
        resume:"傅朝友，南京大学智能科学与技术学院研究员、助理教授、博导，入选中国科协“青年人才托举工程”。2022年博士毕业于中科院自动化所模式识别实验室。研究方向为多模态内容分析，谷歌学术引用8800余次，2篇一作单篇引用过千次，6篇一作单篇引用过百次，开源项目累计获得2万余次GitHub Stars。代表性工作包括VITA多模态大模型系列（VITA-1.0/-1.5、VITA-Audio），MME多模态评测基准系列（MME、Video-MME/-v2）和Awesome-MLLM社区等。担任Pattern Recognition/IEEE T-BIOM期刊编委、ICLR/ICML会议领域主席、CSIG青工委委员、CCF-AI/-CV专委会执行委员。曾获小米青年学者-科技创新奖、华为紫金学者、世界人工智能大会云帆奖、中科院院长特别奖、IEEE Biometrics Council Best Doctoral Dissertation Award、北京市优博、中科院优博。个人主页：https://bradyfu.github.io/"
      },
      {
        name:"仉尚航",
        organization:"北京大学",
        image:aprspeakersImgRoot+"zhangsanghang.jpg",
        reportTitle:"开放世界具身智能多模态大模型与大数据",
        reportAbstract:"具身智能多模态大模型引领了人工智能与机器人融合研究的新范式，而现实世界中的具身智能体往往面对开放环境中跨本体、跨场景、跨任务等泛化性挑战，如何以具身大模型为基础让机器人像人一样运动和思考成为关键难题。本次报告将介绍一系列关于具身智能多模态大模型的研究工作，包括具身大脑大模型、具身智能端到端视觉-语言-动作大模型、具身世界模型、具身大数据，并最终介绍从一体化到自进化的技术发展趋势。",
        resume:"仉尚航，北京大学计算机学院研究员，致力于具身智能多模态大模型方向研究，荣获世界人工智能顶级会议AAAI 2021最佳论文奖，谷歌学术引用逾2.7万余次。由Springer Nature出版《Deep Reinforcement Learning》，入选中国作者年度高影响力研究精选。曾获ICCV持续学习国际竞赛第一名、世界人形机器人运动会最佳互动奖、中关村仿生机器人大赛优胜奖，中国图象图形学学会石青云女科学家奖、教育部华为智能基座奖等奖项。入选美国“EECS Rising Star”、全球AI华人女性青年学者榜、工信部人形机器人标准化技术委员会委员、AI100青年先锋、全球前2%顶尖科学家榜单。"
      },
    ]
  },
  tutorial:{
    t1:[
      // {
      //   name:"王立威",
      //   image:tutorialImgRoot+"wangliwei.jpg",
      //   organization:'北京大学',
      //   intr:"王立威 北京大学智能学院教授。长期从事机器学习研究。在机器学习理论方面取得一系列成果。在机器学习国际权威期刊会议发表高水平论文200余篇。曾获机器学习顶级会议NeurIPS 2024最佳论文奖，ICLR 2023杰出论文奖、ICLR 2024杰出论文提名奖。担任人工智能权威期刊TPAMI编委。曾入选AI’s 10 to Watch，是首位入选的中国学者。",
      //   content:"经典机器学习理论关于表示、优化、泛化三方面的研究在大模型时代遇到严峻挑战。由于训练中数据的单次（或少次）使用方式，传统优化与泛化问题在大模型中几乎不再存在。另一方面，由于思维链的广泛应用，大模型的表示问题也已不再限于神经网络本身。本报告将探讨大模型中机器学习的新问题新理论以及相应方法。分别探讨表示、优化与泛化理论基础与前沿。",
      //   title:"大模型时代机器学习理论"
      // },
      
    ],
    t2:[
      
      
    ],
    t3:[
      
    ],
    t4:[
      
      
    ]
  },
  workshopList:[
    
    // {
    //   title:"",
    //   enTitle:"",
    //   time:"",
    //   content:"",
    //   organizers:[
    //     {
    //       name:"余肇飞",
    //       unit:"北京大学",
    //       homepage:"",
    //       email:"",
    //       resume:"",
    //       image:workshopImgRoot+"yuzhaofei.jpg"
    //     },
        
    //   ],
    //   arrange:"",
    //   speakers:[
    //     // {
    //     //   name:"李国齐",
    //     //   unit:"中国科学院自动化所",
    //     //   homepage:"",
    //     //   image:workshopImgRoot+"liguoqi.jpg",
    //     //   resume:"",
    //     //   reportTitle:"类脑大模型",
    //     //   reportAbstract:"",
    //     // },
        
    //   ],
    //   panelGuests:[
    //     ''
    //   ],
    //   reportAndPanel:[
          
    //   ]
    // },  //
    
   
  ],
  jiudian:[
    

  ],
  agenda: {
      
    }
}


// WEBPACK FOOTER //
// ./src/router/Dicts.js